import { XCircle } from 'lucide-react';

interface ErrorAlertProps {
  error?: string | null;
  onClose?: () => void;
}

export function ErrorAlert({ error, onClose }: ErrorAlertProps) {
  if (!error) return null;

  return (
    <div className="mb-4 p-4 bg-red-50 rounded-md">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircle className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-red-700">{error}</p>
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              className="ml-3 flex-shrink-0 text-sm font-medium text-red-700 hover:text-red-600"
              data-ph-capture-attribute="btn-error-alert-dismiss"
            >
              Dismiss
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
